// project
import { AssetPointer } from "@/psychlab/types/assets";
import { Graph, GraphNode } from "@/psychlab/types/graph";
import { Form } from "@/psychlab/types/form";
import { Scene } from "@/psychlab/types/scene";
import { UpdateReport, UpdateEntry } from "./UpdateReport";
import * as AssetAPI from "@/services/api/assets";

export const getUpdateReport = async (g:Graph):Promise<UpdateReport> => {
	const nodes = Object.keys(g.nodes).map(k => g.nodes[k]);
	const r = await Promise.all(nodes.map(node => {
		const p = processors[node.type];
		return p ? p(node) : new Promise((r,_) => r([]));
	}) as Promise<UpdateEntry[]>[]);
	const entries:UpdateEntry[] = [];
	r.forEach(ee => entries.push(...ee));

	return {
		entries,
	}
};

type AssetNode<T> = GraphNode<{
	asset:AssetPointer<T>|undefined|null;
}>;

type NodeProcessor = (node:GraphNode<any>) => Promise<UpdateEntry[]>;

const getAssetEntry = async (node:AssetNode<any>):Promise<UpdateEntry[]> => {
	if(!node.parameters.asset || !node.parameters.asset.ref) { return []; };
	const asset = node.parameters.asset.ref.asset;
	const version = node.parameters.asset.ref.version;
	try {
		const a = await AssetAPI.getAsset(asset);
		const v = await AssetAPI.getAssetVersion(asset, "latest", "+data");

		if(version === v._id){ return []; }

		const entry:UpdateEntry = {
			description:`${a.name}`,
			async handler(){
				node.parameters.asset = {
					ref:{
						asset,
						version:v._id
					},
					data:v.data
				};
				return null;
			}
		}

		return [
			entry,
		];
	}
	catch{}
	return [];
};


const getSceneEntry = async (node:GraphNode<Scene>):Promise<UpdateEntry[]> => {

	const entries:(UpdateEntry|null)[] = node.parameters.points.map(p => null);

	try { 
		await Promise.all(node.parameters.points.map((p, i) => {

			return new Promise<void>(async (resolve, reject) => {
	
				if(!p.form){ return resolve(); }
		
				const formRef = (p.form as AssetPointer<Form>).ref;
		
				if(!formRef){ return resolve(); }
				
				const asset = formRef.asset;
				const version = formRef.version;
	
				const a = await AssetAPI.getAsset(asset);
				const v = await AssetAPI.getAssetVersion(asset, "latest", "+data");
	
				if(version === v._id){ return resolve(); }


	
				entries[i] = {
					description:`${i + 1}: ${a.name}`,
					async handler(){
						p.form = {
							ref:{
								asset:formRef.asset,
								version:v._id
							},
							data:v.data
						}
						return null;
					}
				}
				resolve();
			});
	
		}));
	}
	catch{}
	return entries.filter(e => e !== null) as UpdateEntry[];
};


const processors:{ [k:string]:NodeProcessor } = {
	"Form":getAssetEntry,
	"Gallery":getAssetEntry,
	"CognitiveTest":getAssetEntry,
	"Scene":getSceneEntry,
};